var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid\">\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<h1>Access Denied</h1>\n</div>\n</div>\n</div>";
var id1="access_denied.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/components/access_denied/access_denied.html
// module id = 2639
// module chunks = 1